import { Pick } from '@40seas/entities/common';
import { HeronCompany } from './heron-company.entity';

export class CreateHeronCompanyDto extends Pick(HeronCompany, ['buyer'], ['heronId']) {}
